import axios from 'axios';

const CEP_API_BASE_URL = 'https://viacep.com.br/ws';

export const fetchAddressByCEP = async (cep) => {
  try {
    // Limpar o CEP removendo caracteres não numéricos
    const cleanCEP = cep.replace(/\D/g, '');
    
    if (cleanCEP.length !== 8) {
      throw new Error('CEP deve ter 8 dígitos');
    }

    const response = await axios.get(`${CEP_API_BASE_URL}/${cleanCEP}/json/`);
    
    // Verificar se a resposta tem erro
    if (response.data.erro) {
      throw new Error('CEP não encontrado');
    }

    // Retornar os dados diretamente
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    throw error;
  }
};

export const formatCEP = (cep) => {
  if (!cep) return '';
  const cleanCEP = cep.replace(/\D/g, '');
  if (cleanCEP.length === 8) {
    return `${cleanCEP.slice(0, 5)}-${cleanCEP.slice(5)}`;
  }
  return cep;
};
